<template>
  <main-content>
    <b-card>
      <ERegistrationHeaderFormInfo />
      <ERegistrationOwnerUpgradeForm :invitation-key="invitationKey" />
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationOwnerUpgradeForm from "../components/e-registration-owner-upgrade/ERegistrationOwnerUpgradeForm";
import ERegistrationHeaderFormInfo from "../components/e-registration-header-form/ERegistrationHeaderFormInfo"

export default {
  components: {
    ERegistrationHeaderFormInfo,
    ERegistrationOwnerUpgradeForm
  },
  props: {
    invitationKey: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped></style>
